//istitleshow:是否显示右下角年度，ispercentshow：是否显示%,isnegative代表图4，chartdiv是echart外的div
export function barscroll(barscroll, barscrollData, chartnum, istitleshow, ispercentshow, isnegative, chartdiv) {
  barscroll.clear();

  var playInterval = 2000;
  var unit = {
    '0': '',
    '1': '万',
    '2': '亿',
    '3': '兆'
  };

  function compare(p) { //比较函数
    return function (m, n) {
      var a = m[p];
      var b = n[p];
      if (!isnegative)
        return a - b;
      else
        return b - a;
    }
  }
  // 千分位
  function formatNum(strNum) {
    if (Math.round(strNum) <= 10 && strNum.length <= 3) {
      return strNum;
    }
    var u0 = 0
    while (Math.round(strNum) > 1000000 && u0 < 3) {
      strNum = Math.round(Math.round(strNum) / 10000);
      u0 = u0 + 1
    }

    if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(strNum)) {
      return strNum;
    }
    var a = RegExp.$1,
      b = RegExp.$2,
      c = RegExp.$3;
    var re = new RegExp();
    re.compile("(\\d)(\\d{3})(,|$)");
    while (re.test(b)) {
      b = b.replace(re, "$1,$2$3");
    }
    return a + "" + b + "" + c + unit[String(u0)];
  }
  let gridright = '10%';
  if (istitleshow)
    gridright = '20%';

  var option = {
    baseOption: {
      timeline: {
        show: istitleshow,
        // orient: 'vertical',
        axisType: 'category',
        orient: 'horizontal',
        autoPlay: true,
        loop: true,
        playInterval: playInterval,
        right: '0%',
        top: '84%',
        left: '68%',
        z: 100,
        label: {
          normal: {
            show: false,
            interval: 0,
          }
        },
        symbol: 'none',
        lineStyle: {
          color: '#ccc',
          show: false
        },
        checkpointStyle: {
          symbol: 'none',
          color: '#bbb',
          borderColor: '#777',
          show: false,
          borderWidth: 1
        },
        controlStyle: {
          showNextBtn: istitleshow,
          showPrevBtn: istitleshow,
          position: 'bottom',
          itemSize: 35,
          normal: {
            color: '#bfbfbf',
            show: true,
            borderColor: '#bfbfbf'
          },
          emphasis: {
            color: '#aaa',
            borderColor: '#aaa'
          }
        },
        data: barscrollData.map(function (ele) {
          return ele.date
        })
      },
      tooltip: {
        trigger: "item",
      },
      title: [{
        textStyle: {
          fontSize: 17,
        }
      }],
      grid: [{
        left: '15%',
        right: gridright,
        top: '1%',
        height: 'auto',
        bottom: '1%'
      }],
      xAxis: [{}],
      yAxis: [{}],
      series: [{
        id: 'bar',
        type: 'bar',
        barWidth: '30',
        tooltip: {
          show: false
        },
        label: {
          normal: {
            show: false,
            position: 'right'
          }
        },
        data: []
      }]
    },
    options: []
  }

  var xMaxInterval = 0;

  for (var i = 0; i < barscrollData.length; i++) {
    var xMin = 9999999;
    var xMax = 0;

    for (var j = 0; j < barscrollData[i].data.length; j++) {
      if (parseFloat(barscrollData[i].data[j].value) < xMin) {
        xMin = barscrollData[i].data[j].value;
      }
    }
    //因为有的国旗位置不正确，因此加上min
    if (!isnegative) { //图4默认最大
      if (xMin >= 12)
        xMin = xMin - 12;
      else
        xMin = xMin - 5.5;
    }

    if (barscrollData[i].data[0].value > 0.00001) {
      xMax = 'dataMax'
    }
    if (barscrollData[i].data[0].value / xMaxInterval >= 10) {
      xMaxInterval = barscrollData[i].data[0].value / 5
    }

    var rankdatamap = barscrollData[i].data.map(function (ele) {
      return ele
    });
    rankdatamap.sort(compare("value"));
    let picdata = [];
    let symbolposition = 'end';
    let inverse=false;
    if(isnegative)
    inverse=true;

    let symbolSize1 = '';
    let symbolSize2 = '';
    for (var count = 0; count < rankdatamap.length; count++) {
      symbolSize1 = '22px'; //国旗大小宽
      symbolSize2 = '17px'; //国旗大小高
      picdata.push({
        symbolPosition: symbolposition,
        value: rankdatamap[count].value,
        symbol: setimgsrc(rankdatamap[count].name),
        //symbolSize: ['35px', '30px'], //国旗大小
        symbolSize: [symbolSize1, symbolSize2], //国旗大小
        symbolOffset: ['0', '30%'], //国旗显示在条状图的最下 
      });
    }

    option.options.push({
      title: {
        show: istitleshow,
        text: barscrollData[i].category,
        right: "0%",
        left: "80%",
        bottom: '5%', 
        textStyle: {
          fontSize: 32,
          color: '#B6B6B6'
        },
      },
      xAxis: [{
        show: false,
        type: 'value',
        scale: true,
        interval: xMaxInterval,
        min: xMin,
        // max: xMax,
        inverse:inverse,//是否是反向坐标轴，默认false
        axisTick: {
          show: false
        },
        axisLabel: {
          show: true,
          color: 'rgba(121,121,121,0.9)',
          formatter: function (value, index) {

            // 空一格显示一次坐标值
            if (index % 2 === 0) {
              var u = 0
              while (value > 100000 && u < 3) {
                value = Math.round(value / 10000);
                u = u + 1
              }
              return String(value) + unit[String(u)]
            } else {
              return '';
            }
          },
          textStyle: {
            color: 'rgba(121,121,121,0.9)'
          }
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: 'rgba(121,121,121,0.3)'
          }
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: ['rgba(121,121,121,0.3)', 'rgba(121,121,121,0)']
          }
        }
      }],
      yAxis: [{
        type: 'category',
        axisTick: {
          show: false
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: 'rgba(121,121,121,0.3)'
          }
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#000'
          }
        },
        data: rankdatamap.map(function (ele) {
          return ele.name
        })
      }],
      series: [{
        id: 'bar',
        itemStyle: {
          normal: {
            color: function (params) {
              var colorListr = ["#47aeee", "#777bc9", "#34a556", "#89c05e", "#bed647", "#ff6565", "#2c5ca7", "#efc81e", "#e0851f", "#34acb0"];
              if (chartnum == 2)
                // colorListr = ["#dcedc8", "#dcedc8", "#c5e1a5", "#aed581", "#9ccc65", "#8bc34a", "#7cb342", "#689f38", "#558b2f", "#33691e", ];
                colorListr = ["#d0eafb", "#b9e0f9", "#a2d6f6", "#8accf4", "#73c1f2", "#5cb7f0", "#47aeee", "#44adee", "#2da3ec", " #1698e9"]
                // colorListr = ["#c4ecee", "#b0e6e8", "#9de0e2", "#89d9dc", "#75d3d6", "#62cdd0", "#4ec7cb", "#3ac0c5", "#34acb0", "#2f9a9d", ]
              if (chartnum == 3)
                colorListr = ["#ffecb3", "#ffe0b2", "#ffcc80", "#ffb74d", "#ffa726", "#ff9800", "#fb8c00", "#f57c00", "#ef6c00", "#e65100"];
              if (chartnum == 4)
                // colorListr = ["#dcedc8", "#dcedc8", "#c5e1a5", "#aed581", "#9ccc65", "#8bc34a", "#7cb342", "#689f38", "#558b2f", "#33691e"];
                colorListr = ["#d0eafb", "#b9e0f9", "#a2d6f6", "#8accf4", "#73c1f2", "#5cb7f0", "#47aeee", "#44adee", "#2da3ec", " #1698e9"]
              return colorListr[params.dataIndex]
            },
            label: {
              show: true,
              position: 'top',
              formatter: '{c}%'
            },
            shadowColor: 'rgba(40, 40, 40, 0.5)',
          }
        },
        label: {
          normal: {
            position: 'right',
            color: '#000',
            formatter: function (p) {
              // console.log(p);
              
              if (!ispercentshow)
                return formatNum(Math.round(p.value * 100) / 100);
                // return formatNum(p.value);
              else
                return formatNum(p.value) + '%';
            }
          }
        },
        data: rankdatamap.map(function (ele) {
          return ele.value;
        })
      }, {
        type: 'pictorialBar',
        z: 10,
        data: picdata
      }]
    })
  };

  barscroll.setOption(option, true)
  window.addEventListener("resize", barscroll.resize)

  //条形图国旗
  function setimgsrc(name) {
    try {
      let gbimgs = require("@/assets/imgs/flag/" + name + ".png");
      return "image://" + gbimgs;
    } catch (err) {
      let gberrorimg = require("@/assets/imgs/flag/default.png");
      return "image://" + gberrorimg;
    }
  }
}
